import { Config } from "../../../configurations/config";

export const EmployeeWorkStatus_API = {
  GetEmployeeStatusList: `${Config.server_url}${Config.api_prefix}/Employee/GetEmployeeStatusList`,
  GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees?AllEmployees=true`,
  GetEmployeeWorkStatusPagination: `${Config.server_url}${Config.api_prefix}/Employee/EmployeeWorkStatus`,
  PostEmployeeWorkStatus: `${Config.server_url}${Config.api_prefix}/Employee/EmployeeWorkStatus`,
};
